import React from 'react';
import './Skills.css';

const skills = [
  { name: 'Java', value: 87, icon: '🧑‍💻💻' },
  { name: 'SpringBoot', value: 80, icon: '🌱' },
  { name: 'HTML', value: 99, icon: '📄' },
  { name: 'CSS', value: 90, icon: '🎨' },
  { name: 'React JS', value: 90, icon: '🧬' },
  { name: 'MySQL', value: 90, icon: '💾' },
  { name: 'JavaScript', value: 85, icon: '📜' },
  { name: 'Hibernate', value: 80, icon: '📘' },
  { name: 'Angular', value: 75, icon: '🅰️' },
  { name: 'Spring', value: 70, icon: '🌿' },
  { name: 'Mongo DB', value: 85, icon: '🪴' },
  { name: 'Oracle', value: 60, icon: '🌕' },
];

const Skills = () => {
  return (
    // <div className="skills-container">
    <div className="skills-container" id="skills">

      <h2 className="skills-title">Skills</h2>
      <p className="skills-subtitle">I've completed my projects using these technologies</p>
      <div className="skills-grid">
        {skills.map((skill, i) => (
          <div className="skill-card" key={i}>
            <div className="progress-circle" style={{ '--value': skill.value }}>
              <span className="percentage">{skill.value}%</span>
            </div>
            <div className="skill-icon">{skill.icon}</div>
            <p className="skill-name">{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
